// extracted by mini-css-extract-plugin
module.exports = {"layoutPreview":"style__layoutPreview__vnbKb","areaPlaceholder":"style__areaPlaceholder__xsdub","right":"style__right__WW4Ow","wrong":"style__wrong__cdzbh"};